/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ReadMessageResult {
  Error = 0,
  Success = 1,
  RequestValidationFailed = 2,
  InvalidCase = 3,
  InvalidMessage = 4,
}
